import _ from 'lodash';
import { PreservationTable, AccountType as ACCOUNT_TYPE, MemberType as MEMBER_TYPE } from 'super-engine';
import { Constants as CONSTANTS, EmployerType as EMPLOYER_TYPE } from '@/constants';
import {
  getValue, set, afterSet, curry, curryPartner, sendGAView,
} from './helpers';


function fnEmployerType(modifier) {
  return function EmployerType(state, employerType, property, args) {
    if (employerType === EMPLOYER_TYPE.GOVERNMENT) {
      set(state, {
        key: `inputs.Working${modifier}`,
        value: true,
      });

      if (_.isUndefined(args.skipMemberContributionsSet)) {
        set(state, {
          key: `inferred.MemberContributions${modifier}`,
          value: 5,
          args: { skipEmployerAfterSet: true },
        });
      }

      set(state, {
        key: 'inputs.InsurancePremium',
        value: CONSTANTS.DEFAULT_INSURANCE_PREMIUM,
      });

      set(state, {
        key: 'inferred.InsurancePremium',
        value: CONSTANTS.DEFAULT_INSURANCE_PREMIUM,
      });

      if (getValue(state, `inferred.AccruedDBMultiple${modifier}`) > 0) {
        set(state, {
          key: `inputs.AccountType${modifier}`,
          value: ACCOUNT_TYPE.DEFINED_BENEFIT,
        });

        if (getValue(state, `inferred.DBContributionRate${modifier}`) === CONSTANTS.POLICE_CONTRIBUTION_RATE) {
          set(state, {
            key: `inputs.MemberType${modifier}`,
            value: MEMBER_TYPE.QSUPER_POLICE,
          });
          //
        } else {
          set(state, {
            key: `inputs.MemberType${modifier}`,
            value: MEMBER_TYPE.QSUPER_DEFAULT,
          });
        }
        //
      } else {
        set(state, {
          key: `inputs.AccountType${modifier}`,
          value: ACCOUNT_TYPE.ACCUMULATION,
        });

        if (getValue(state, `inferred.QSuperAccumulationMemberContributionRate${modifier}`) === CONSTANTS.POLICE_CONTRIBUTION_RATE) {
          set(state, {
            key: `inputs.MemberType${modifier}`,
            value: MEMBER_TYPE.QSUPER_POLICE,
          });
          //
        } else {
          set(state, {
            key: `inputs.MemberType${modifier}`,
            value: MEMBER_TYPE.QSUPER_DEFAULT,
          });
        }
      }
      //
    } else if (employerType === EMPLOYER_TYPE.NON_GOVERNMENT) {
      set(state, {
        key: `inputs.Working${modifier}`,
        value: true,
      });

      if (_.isUndefined(args.skipMemberContributionsSet)) {
        set(state, {
          key: `inferred.MemberContributions${modifier}`,
          value: 0,
          args: { skipEmployerAfterSet: true },
        });
      }

      set(state, {
        key: `inputs.AccruedDBMultiple${modifier}`,
        value: 0,
      });

      set(state, {
        key: `inputs.AccountType${modifier}`,
        value: ACCOUNT_TYPE.ACCUMULATION,
      });

      set(state, {
        key: `inputs.MemberType${modifier}`,
        value: MEMBER_TYPE.QSUPER_NON_GOVERNMENT,
      });

      set(state, {
        key: 'inputs.InsurancePremium',
        value: CONSTANTS.DEFAULT_INSURANCE_PREMIUM,
      });

      set(state, {
        key: 'inferred.InsurancePremium',
        value: CONSTANTS.DEFAULT_INSURANCE_PREMIUM,
      });

      //
    } else if (employerType === EMPLOYER_TYPE.SELF_OR_NOT_EMPLOYED) {
      set(state, {
        key: `inputs.Working${modifier}`,
        value: false,
      });

      if (_.isUndefined(args.skipMemberContributionsSet)) {
        set(state, {
          key: `inferred.MemberContributions${modifier}`,
          value: 0,
          args: { skipEmployerAfterSet: true },
        });
      }

      set(state, {
        key: `inputs.AccruedDBMultiple${modifier}`,
        value: 0,
      });

      set(state, {
        key: `inputs.AccountType${modifier}`,
        value: ACCOUNT_TYPE.ACCUMULATION,
      });

      set(state, {
        key: `inputs.MemberType${modifier}`,
        value: 0,
      });

      set(state, {
        key: 'inputs.InsurancePremium',
        value: 0,
      });
    }
  };
}

export const EmployerType = curry(fnEmployerType);
export const EmployerType2 = curryPartner(fnEmployerType);

function fnDefinedBenefit(modifier) {
  return function DefinedBenefit(state, definedBenefit) {
    const salary = getValue(state, `inputs.Salary${modifier}`);
    const accrued = salary === 0 ? 0 : definedBenefit / salary;

    set(state, {
      key: `inferred.AccruedDBMultiple${modifier}`,
      value: accrued,
    });
    afterSet(state, `inferred.EmployerType${modifier}`, { skipMemberContributionsSet: true });
  };
}

export const DefinedBenefit = curry(fnDefinedBenefit);
export const DefinedBenefit2 = curryPartner(fnDefinedBenefit);

function fnAge(modifier) {
  return function Age(state, age) {
    const calculationDate = getValue(state, 'inputs.CalculationDate');
    const preservationAge = PreservationTable.createDefault().preservationAge(calculationDate.plus(-0.5 - age));
    set(state, {
      key: `inferred.PreservationAge${modifier}`,
      value: preservationAge,
    });

    set(state, {
      key: `inputs.OneOffContributionMadeAtAge${modifier}`,
      value: Math.max(getValue(state, `inputs.OneOffContributionMadeAtAge${modifier}`), age),
    });
    if (getValue(state, `inputs.AgeNow${modifier}`) >= (CONSTANTS.DEFAULT_RETIREMENT_AGE - 1)) {
      set(state, {
        key: `inputs.RetirementAge${modifier}`,
        value: getValue(state, `inputs.AgeNow${modifier}`) + 1,
      });
    } else if (getValue(state, `inputs.AgeNow${modifier}`) < CONSTANTS.DEFAULT_RETIREMENT_AGE) {
      set(state, {
        key: `inputs.RetirementAge${modifier}`,
        value: CONSTANTS.DEFAULT_RETIREMENT_AGE,
      });
    }

    set(state, {
      key: `inputs.PartTimeWorkFromAge${modifier}`,
      value: Math.max(getValue(state, `inputs.PartTimeWorkFromAge${modifier}`), age),
    });

    if (modifier === CONSTANTS.PARAMETER_PARTNER_SUFFIX) {
      // set(state, {
      //   key: `inputs.RetirementAge${modifier}`,
      //   value: _.max([getValue(state, 'inputs.RetirementAge'), getValue(state, `inputs.AgeNow${modifier}`), preservationAge]),
      // });

      if (getValue(state, `inputs.AgeNow${modifier}`) >= (CONSTANTS.DEFAULT_RETIREMENT_AGE - 1)) {
        set(state, {
          key: `inputs.RetirementAge${modifier}`,
          value: getValue(state, `inputs.AgeNow${modifier}`) + 1,
        });
      } else if (getValue(state, `inputs.AgeNow${modifier}`) < CONSTANTS.DEFAULT_RETIREMENT_AGE) {
        set(state, {
          key: `inputs.RetirementAge${modifier}`,
          value: CONSTANTS.DEFAULT_RETIREMENT_AGE,
        });
      }
    }
  };
}

export const Age = curry(fnAge);
export const Age2 = curryPartner(fnAge);

function fnSalary(modifier) {
  return function Salary(state, salary) {
    // Not sure why we do this?
    set(state, {
      key: `inputs.Salary${modifier}`,
      value: salary,
    });

    if (!getValue(state, 'inferred.HasChangedTargetIncome')) {
      const income = salary * 0.66;
      const partnerModifier = modifier === CONSTANTS.PARAMETER_SUBJECT_SUFFIX ? CONSTANTS.PARAMETER_PARTNER_SUFFIX : CONSTANTS.PARAMETER_SUBJECT_SUFFIX;
      const partnerIncome = getValue(state, 'inputs.IncludePartner') ? getValue(state, `inputs.Salary${partnerModifier}`) * 0.66 : 0;
      const total = income + partnerIncome;

      set(state, {
        key: 'inferred.TargetIncome',
        value: total,
        options: { skipAfterSet: true },
      });

      set(state, {
        key: 'inputs.TargetIncome',
        value: total,
        options: { skipAfterSet: true },
      });
    }
    afterSet(state, `inferred.DefinedBenefit${modifier}`);
  };
}

export const Salary = curry(fnSalary);
export const Salary2 = curryPartner(fnSalary);


function fnContributionRate(modifier) {
  return function ContributionRate(state, contributionRate, property, args) {
    // 'Non Govt' SG Guarantee Rate - change the first value each year
    const employerRate = (getValue(state, `inferred.EmployerType${modifier}`) === EMPLOYER_TYPE.NON_GOVERNMENT) ? {
      0.00: 12,
      0.01: 12,
      0.02: 12,
      0.03: 12,
      0.04: 12,
      0.05: 12,
      0.06: 18,
      0.07: 18,
      0.08: 18,
      0.09: 18,
      0.10: 18,
    }[contributionRate.toString()] : {
      0.00: 12.75,
      0.01: 12.75,
      0.02: 12.75,
      0.03: 12.75,
      0.04: 12.75,
      0.05: 12.75,
      0.06: 18,
      0.07: 18,
      0.08: 18,
      0.09: 18,
      0.10: 18,
    }[contributionRate.toString()];

    set(state, {
      key: `inferred.EmployerContributionRate${modifier}`,
      value: employerRate,
    });

    set(state, {
      key: `inferred.DBContributionRate${modifier}`,
      value: contributionRate,
    });

    set(state, {
      key: `inferred.QSuperAccumulationMemberContributionRate${modifier}`,
      value: contributionRate,
    });

    if (_.isUndefined(args.skipEmployerAfterSet)) {
      afterSet(state, `inferred.EmployerType${modifier}`, { skipMemberContributionsSet: true });
    }
  };
}

export const ContributionRate = curry(fnContributionRate);
export const ContributionRate2 = curryPartner(fnContributionRate);


function fnEmployerContributionRate(modifier) {
  return function EmployerContributionRate(state, employerContributionRate) {
    const rate = getValue(state, `inputs.AccountType${modifier}`) === ACCOUNT_TYPE.ACCUMULATION ? employerContributionRate : 0;

    set(state, {
      key: `inputs.EmployerContributionRate${modifier}`,
      value: rate,
    });
  };
}

export const EmployerContributionRate = curry(fnEmployerContributionRate);
export const EmployerContributionRate2 = curryPartner(fnEmployerContributionRate);


function fnSuperannuationBalance(modifier) {
  return function SuperannuationBalance(state) {
    const accumulation = getValue(state, `inferred.Accumulation${modifier}`);
    const otherFunds = getValue(state, `inferred.OtherFunds${modifier}`);

    set(state, {
      key: `inputs.SuperannuationBalance${modifier}`,
      value: accumulation + otherFunds,
    });
  };
}

export const SuperannuationBalance = curry(fnSuperannuationBalance);
export const SuperannuationBalance2 = curryPartner(fnSuperannuationBalance);


function fnPreTaxMemberContributionsFrequency(modifier) {
  return function PreTaxMemberContributionsFrequency(state, frequency) {
    const contributions = getValue(state, `inputs.PreTaxMemberContributions${modifier}`);

    set(state, {
      key: `inferred.PreTaxMemberContributions${modifier}`,
      value: contributions / frequency,
    });
  };
}

export const PreTaxMemberContributionsFrequency = curry(fnPreTaxMemberContributionsFrequency);
export const PreTaxMemberContributionsFrequency2 = curryPartner(fnPreTaxMemberContributionsFrequency);


function fnPreTaxMemberContributions(modifier) {
  return function PreTaxMemberContributions(state, contribution) {
    const frequency = getValue(state, `inferred.PreTaxMemberContributionsFrequency${modifier}`);

    set(state, {
      key: `inputs.PreTaxMemberContributions${modifier}`,
      value: contribution * frequency,
    });
  };
}

export const PreTaxMemberContributions = curry(fnPreTaxMemberContributions);
export const PreTaxMemberContributions2 = curryPartner(fnPreTaxMemberContributions);


function fnPostTaxMemberContributionsFrequency(modifier) {
  return function PostTaxMemberContributionsFrequency(state, frequency) {
    const contribution = getValue(state, `inputs.PostTaxMemberContributions${modifier}`);

    set(state, {
      key: `inferred.PostTaxMemberContributions${modifier}`,
      value: contribution / frequency,
    });
  };
}

export const PostTaxMemberContributionsFrequency = curry(fnPostTaxMemberContributionsFrequency);
export const PostTaxMemberContributionsFrequency2 = curryPartner(fnPostTaxMemberContributionsFrequency);


function fnPostTaxMemberContributions(modifier) {
  return function PostTaxMemberContributions(state, contribution) {
    const frequency = getValue(state, `inferred.PostTaxMemberContributionsFrequency${modifier}`);

    set(state, {
      key: `inputs.PostTaxMemberContributions${modifier}`,
      value: contribution * frequency,
    });
  };
}

export const PostTaxMemberContributions = curry(fnPostTaxMemberContributions);
export const PostTaxMemberContributions2 = curryPartner(fnPostTaxMemberContributions);


// These are only for the subject so don't need to be curried
export function OneOffPurchase(state, oneOffPurchase) {
  if (getValue(state, 'inputs.IncludePartner')) {
    const halvedValue = oneOffPurchase / 2;

    set(state, {
      key: 'inputs.WithdrawalAtRetirement',
      value: halvedValue,
    });

    set(state, {
      key: `inputs.WithdrawalAtRetirement${CONSTANTS.PARAMETER_PARTNER_SUFFIX}`,
      value: halvedValue,
    });
    //
  } else {
    set(state, {
      key: 'inputs.WithdrawalAtRetirement',
      value: oneOffPurchase,
    });

    set(state, {
      key: `inputs.WithdrawalAtRetirement${CONSTANTS.PARAMETER_PARTNER_SUFFIX}`,
      value: 0,
    });
  }
}


export function Sex(state, sex) {
  set(state, {
    key: 'inputs.RunOutAge',
    // value: sex === 'Male' ? 85 : 92,
    value: sex === 'Male' ? 92 : 92, // was set to 85 if male
  });
}


export function TargetIncome(state, targetIncome) {
  set(state, {
    key: 'inputs.TargetIncome',
    value: targetIncome,
  });

  set(state, {
    key: 'inferred.HasChangedTargetIncome',
    value: true,
  });
}


export function IncludePartner(state, includePartner) {
  set(state, {
    key: 'inputs.Married',
    value: includePartner,
  });

  afterSet(state, 'inferred.OneOffPurchase');
  afterSet(state, 'inferred.Salary');
}


export function GraphType(state, value) {
  // This will clamp to the minimum value it's allowed to be
  set(state, {
    key: 'ui.breakdown.age',
    value: 0,
    options: { skipAfterSet: true },
  });

  sendGAView({
    hitType: 'event',
    eventCategory: 'GraphType',
    eventAction: 'click',
    eventLabel: value,
  });
}


export function BreakdownShow(state, value) {
  sendGAView({
    hitType: 'event',
    eventCategory: 'BreakdownShow',
    eventAction: 'click',
    eventLabel: value ? 'show' : 'hide',
  });
}


export function BreakdownAge(state, value) {
  set(state, {
    key: 'ui.breakdown.show',
    value: true,
  });

  sendGAView({
    hitType: 'event',
    eventCategory: 'BreakdownAge',
    eventAction: 'click',
    eventLabel: value,
  });
}


export function WageInflation(state, value) {
  set(state, {
    key: 'inputs.WageInflationIndex',
    value: [value],
  });
}


export function PriceInflation(state, value) {
  set(state, {
    key: 'inputs.PriceInflationIndex',
    value: [value],
  });
}

// export function ToggleInsurancePremiumOverride(state) {
//   if (getValue(state, 'inputs.InsurancePremium') === CONSTANTS.DEFAULT_INSURANCE_PREMIUM) {
//     set(state, {
//       key: 'inferred.OverrideFundDefaultInsurancePremiums',
//       value: false,
//     });
//     set(state, {
//       key: 'inputs.OverrideFundDefaultInsurancePremiums',
//       value: false,
//     });
//   } else {
//     set(state, {
//       key: 'inferred.OverrideFundDefaultInsurancePremiums',
//       value: true,
//     });
//     set(state, {
//       key: 'inputs.OverrideFundDefaultInsurancePremiums',
//       value: true,
//     });
//   }
// }
